import type { User } from '@/shared/schema';

const STORAGE_KEY = 'iafacil_auth_user';

export function setAuth(user: User | null) {
  try {
    if (user) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(user));
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
  } catch (e) {
    // ignore storage errors
  }
  try {
    window.dispatchEvent(new CustomEvent('iafacil:auth', { detail: user }));
  } catch (e) {
    // ignore
  }
}

export function getAuth(): User | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? (JSON.parse(raw) as User) : null;
  } catch (e) {
    return null;
  }
}

export function clearAuth() {
  setAuth(null);
}

export function subscribeAuth(cb: (user: User | null) => void) {
  const onCustom = (e: Event) => {
    const detail = (e as CustomEvent).detail as User | null;
    cb(detail);
  };
  const onStorage = (e: StorageEvent) => {
    if (e.key === STORAGE_KEY) {
      cb(e.newValue ? (JSON.parse(e.newValue) as User) : null);
    }
  };

  window.addEventListener('iafacil:auth', onCustom as EventListener);
  window.addEventListener('storage', onStorage);

  return () => {
    window.removeEventListener('iafacil:auth', onCustom as EventListener);
    window.removeEventListener('storage', onStorage);
  };
}

export { STORAGE_KEY };
